import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmDialog.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__